// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UsersExportToCsvQueryVariables = PrivateSchemaTypes.Exact<{
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.UserModelAsAdminQueriesFilterInput> | PrivateSchemaTypes.UserModelAsAdminQueriesFilterInput>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  offset?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
}>;


export type UsersExportToCsvQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & { users: Array<(
        { __typename?: 'UserModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.UserModelAsAdminQueries, 'id' | 'email' | 'display_name' | 'first_name' | 'last_name' | 'account_name' | 'phone_number' | 'employee_id' | 'position' | 'location' | 'department' | 'area' | 'timezone' | 'custom_1' | 'custom_2' | 'custom_3' | 'last_activity_at' | 'memberInGroups' | 'manager_id'>
        & { manager?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'account_name' | 'display_name'>
        )> }
      )> }
    )> }
  )> }
);


export const UsersExportToCsvDocument = gql`
    query usersExportToCsv($filters: [UserModelAsAdminQueriesFilterInput!], $limit: NonNegativeInt, $offset: NonNegativeInt) {
  admin {
    organisation {
      users(
        order: {name: "users.id"}
        filters: $filters
        offset: $offset
        limit: $limit
      ) {
        id
        email
        display_name
        first_name
        last_name
        account_name
        phone_number
        employee_id
        position
        location
        department
        area
        timezone
        custom_1
        custom_2
        custom_3
        last_activity_at
        memberInGroups
        manager_id
        manager {
          id
          email
          account_name
          display_name
        }
      }
    }
  }
}
    `;

/**
 * __useUsersExportToCsvQuery__
 *
 * To run a query within a React component, call `useUsersExportToCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersExportToCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersExportToCsvQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useUsersExportToCsvQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersExportToCsvQuery, UsersExportToCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersExportToCsvQuery, UsersExportToCsvQueryVariables>(UsersExportToCsvDocument, options);
      }
export function useUsersExportToCsvLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersExportToCsvQuery, UsersExportToCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersExportToCsvQuery, UsersExportToCsvQueryVariables>(UsersExportToCsvDocument, options);
        }
export type UsersExportToCsvQueryHookResult = ReturnType<typeof useUsersExportToCsvQuery>;
export type UsersExportToCsvLazyQueryHookResult = ReturnType<typeof useUsersExportToCsvLazyQuery>;
export type UsersExportToCsvQueryResult = Apollo.QueryResult<UsersExportToCsvQuery, UsersExportToCsvQueryVariables>;